import { __decorate } from "tslib";
import { Component, Prop, Mixins } from 'vue-property-decorator';
import ActionButton from '@/components/action_button/Index.vue';
import { Getter, Mutation } from 'vuex-class';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
let ConfirmationDialog = class ConfirmationDialog extends Mixins(ViewportSizeMixin) {
    confirmed() {
        this.$emit('confirm');
    }
    onCancel() {
        this.hideConfirmationDialog();
        this.$emit('cancel');
    }
};
__decorate([
    Getter('toggleConfirmation')
], ConfirmationDialog.prototype, "toggleConfirmation", void 0);
__decorate([
    Mutation('hideConfirmationDialog')
], ConfirmationDialog.prototype, "hideConfirmationDialog", void 0);
__decorate([
    Prop({ type: String })
], ConfirmationDialog.prototype, "actionMessage", void 0);
__decorate([
    Prop({ type: String, default: 'Remove?' })
], ConfirmationDialog.prototype, "message", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ConfirmationDialog.prototype, "requestOnProcess", void 0);
__decorate([
    Prop({ type: String, default: 'Confirm Delete' })
], ConfirmationDialog.prototype, "header", void 0);
__decorate([
    Prop({ type: String, default: 'Delete' })
], ConfirmationDialog.prototype, "confirmLabel", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ConfirmationDialog.prototype, "remove", void 0);
__decorate([
    Prop({ type: String, default: '400' })
], ConfirmationDialog.prototype, "width", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ConfirmationDialog.prototype, "important", void 0);
ConfirmationDialog = __decorate([
    Component({
        components: {
            ActionButton,
        },
    })
], ConfirmationDialog);
export default ConfirmationDialog;
